import styled from 'styled-components'

export const Body = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
}))

export const Subtitle = styled.p(({ theme }) => ({
  color: theme.colors.black400,
  fontSize: '1.4rem',
  margin: 0,
}))

export const TableWrapper = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  overflow: 'hidden',
}))

export const Table = styled.table(() => ({
  borderCollapse: 'collapse',
  fontSize: '1.4rem',
  width: '100%',
}))

export const Thead = styled.thead(({ theme }) => ({
  backgroundColor: theme.colors.gray100,
}))

export const Th = styled.th(({ theme }) => ({
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  color: theme.colors.black400,
  fontWeight: 500,
  padding: `${theme.space['8']} ${theme.space['12']}`,
  textAlign: 'left',
  whiteSpace: 'nowrap',
}))

export const Tr = styled.tr(({ theme }) => ({
  '&:not(:last-child)': {
    borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  },
}))

export const FieldTd = styled.td(({ theme }) => ({
  color: theme.colors.black400,
  padding: `${theme.space['10']} ${theme.space['12']}`,
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
}))

export const PrevTd = styled.td(({ theme }) => ({
  color: theme.colors.black400,
  padding: `${theme.space['10']} ${theme.space['12']}`,
  verticalAlign: 'middle',
}))

export const ArrowTd = styled.td(({ theme }) => ({
  padding: `${theme.space['10']} ${theme.space['6']}`,
  verticalAlign: 'middle',
  width: '1px',
}))

export const NewTd = styled.td(({ theme }) => ({
  color: theme.colors.black800,
  fontWeight: 600,
  padding: `${theme.space['10']} ${theme.space['12']}`,
  verticalAlign: 'middle',
}))

export const ArrayList = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
}))

export const ArrayItem = styled.span(({ theme }) => ({
  color: theme.colors.black700,
}))

export const RemovedItem = styled.span(({ theme }) => ({
  color: theme.colors.black400,
  textDecoration: 'line-through',
}))

export const AddedItem = styled.span(({ theme }) => ({
  color: theme.colors.black800,
  fontWeight: 600,
}))
